import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BasicBreadcrumbs from "@material-ui/core/Breadcrumbs";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import ButtonIconComponent from "../Components/ButtonIcons";
import InputField from "../Components/inputfield";
import {
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import ButtonComponent from "../Components/buttton";
import { AddSingleDoc, GetAllData, UpdateSingleDoc, DeleteSingleData } from "../NetworkCalls/Admin/ServerReq";
import RemoveButton from "../Components/AlertDialog";

const Divider = styled(MuiDivider)(spacing);


const AddAmenite = () => {
  const Food_Category = [{ id: 1, name: 'Appetizer and Soup' }, { id: 2, name: 'Appetizer', }, { id: 3, name: 'Appetizer and Soup' }, { id: 4, name: 'Appetizer', }]
  const [categoryIndex, setCategoryIndex] = useState(0)
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState()
  const [amenity, setAmenity] = useState({})
  const [loaderAddAmenity, setLoaderAddAmenity] = useState(false)


  function handleRemove(id) {
    DeleteSingleData("Amenities", id)

    const result = data?.filter((item) => item?.id != id)
    setData(result);
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setAmenity({ ...amenity, [name]: value })
  }
  useEffect(() => {
    // onAuthStateChanged(auth, (user) => {
    //     if (user) {
    // getData(user.uid);
    getData();
    //     }
    // });
  }, []);

  const getData = async () => {
    try {
      setLoader(true)
      let arr = [];
      const response = await GetAllData("Amenities");
      response.forEach((doc) => {
        arr.push(doc.data())
      });

      arr.sort((a, b) => a.name.localeCompare(b.name));

      setData(arr)
      setLoader(false)
    } catch (error) {
      console.log(error)
      setLoader(false)
    }
  }
  const handleEdit = () => {
    // data?.filter((i)=> )
  }
  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px" }}
        justify='space-between'
        container
        spacing={24}>
        <Grid item>
          <Typography
            gutterBottom
            variant='h3'
            display='inline'
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
            }}>
            Dashboard
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />
      {loader ?
        (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        )
        :
        <div className='dashboard_container' style={{ backgroundColor: '#fff', border: '1px solid rgba(76, 78, 100, 0.25)', borderRadius: '10px', padding: '10px' }}>
          <div style={{ width: "97%" }}>
            <Grid
              container
              spacing={2}>

            </Grid>
            <Grid>
              <Box mt={5}>
                <Typography style={{ color: "#000", fontSize: 25, fontWeight: 'bold' }}>{"Amenities"}</Typography>
              </Box>
            </Grid>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                setLoaderAddAmenity(true)
                AddSingleDoc("Amenities", amenity).then(() => {
                  setAmenity({});
                  setLoaderAddAmenity(false)
                  window.location.reload(false);
                });
              }}
            >
              <Grid item xs={12} xl={6} lg={6} md={6} style={{ marginTop: 20 }}>
                <Box mb={2}>
                  <InputField
                    type='text'
                    name='name'
                    fullWidth={true}
                    placeholder={"Enter amenity name"}
                    onChange={handleOnChange}
                    require={true}
                  />
                </Box>
                <InputField
                  type='text'
                  name='logo'
                  fullWidth={true}
                  placeholder={"Enter amenity logo id"}
                  onChange={handleOnChange}
                  require={true}
                />
              </Grid>
              <Grid>
                <div style={{ marginTop: '20px', width: '50%' }}>
                  <ButtonIconComponent
                    loader={loaderAddAmenity}
                    name='Add an Amenity'
                    imageBool={true}
                    styles={{ marginLeft: '10px', }}
                    type={'submit'}
                  />
                </div>
              </Grid>

            </form>
            <Grid container spacing={0} >
              {data?.map((i, index) => (
                <Grid item xs={0} sm={4} md={0} key={index} >
                                   
                <Box mt={5} style={{ display: 'flex', alignItems: 'center', width: "70%" }} key={index}>
                    {i?.id != categoryIndex ? (
                      <>
                        <Typography style={{ color: "#000" , marginLeft: 15}}>{i?.name}</Typography>

                        <Tooltip title='Edit Category' onClick={() => setCategoryIndex(i?.id)}>
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>

                        <RemoveButton
                          text={'Are you sure you want to delete this item?'}
                          onRemove={() => handleRemove(i?.id)
                          }
                        />
                      </>
                    )
                      :
                      <>
                        <form onSubmit={(e) => {
                          e.preventDefault()
                          let temp = data?.filter((item) => item?.id == i?.id)
                          // console.log(temp)
                          UpdateSingleDoc("Amenities", temp[0]?.id, temp[0])
                          setCategoryIndex(0)
                        }}
                        style={{
                          width: "100%",

                        }}
                        > 
                        
                        <Grid item xs={12} xl={8} lg={8} md={8} style={{ marginTop: 20, display: 'flex', alignItems: 'center', width: "100%" }}> 
                        
                              <InputField
                                type='text'
                                name='item'
                                fullWidth={true}
                                placeholder={"Enter amenity name"}
                                onChange={(e) => {
                                  const updatedData = data.map(item => {
                                    if (item.id === i?.id) {
                                      return { ...item, name: e.target.value };
                                    }
                                    return item;
                                  });
                                  setData(updatedData)
                                }}
                                value={i?.name}
                              />
                         
                          
                            <InputField
                              type='text'
                              name='id'
                              fullWidth={true}
                              placeholder={"Enter amenity logo id"}
                              onChange={(e) => {
                                const updatedData = data.map(item => {
                                  if (item.id === i?.id) {
                                    return { ...item, logo: e.target.value };
                                  }
                                  return item;
                                });
                                setData(updatedData)
                              }}
                              value={i?.logo}
                            />

                          </Grid>
                          <div style={{ marginTop: '20px', width: '20%', marginLeft: '10px' }}>
                            <ButtonComponent
                              loader={false}
                              name='Save'
                              // onClick={() => setCategoryIndex(0)}
                              imageBool={false}
                              styles={{ marginLeft: '10px' }}
                              type={'submit'}
                            />

                          </div>
                        </form>

                      </>
                    }

                  </Box>

                  {/* <Divider orientation="vertical"
                    style={{
                      alignContent: 'center',
                      backgroundColor: "#000000",
                    }}
                  /> */}

                </Grid>
              ))}
            </Grid>

            {/* <Grid
          container
          justifyContent='center'
          sx={{ marginTop: "30px", width: "50%" }}>
          <ButtonComponent loader={false} name='Save' dashboard={true} />
        </Grid> */}
          </div>
        </div>
      }
    </React.Fragment>
  )
}

export default AddAmenite